/* eslint-disable @typescript-eslint/no-explicit-any */
import { ClientContact, Contact } from 'shared/models';
import { PaginationData } from 'shared/types';
import request from './requesters/client.request';
import  ContactAddress  from 'shared/models/common/client-contact-addresses.model';
const clientContactService = {
  /* eslint-disable-next-line */
  getContacts: (params: any) => request.get<PaginationData<ClientContact>>('/contacts', { params }),
  /* eslint-disable-next-line */
  findContact: (contactId: string, params?: any) => request.get(`/contacts/${contactId}`, { params }),
  /* eslint-disable-next-line */
  findContactByParams: (params: any) => request.get(`/contacts`, { params }),
  /* eslint-disable-next-line */
  createContact: (data: any) => request.post<ClientContact>('/contacts', data),
  createAccountContact: (data: object) => request.post<ClientContact>('/create-account-contacts', data),
  /* eslint-disable-next-line */
  updateContact: (contactId: number, data: any) => request.put<ClientContact>(`/contacts/${contactId}`, data),
  deleteContact: (contactId: number) => request.delete(`/contacts/${contactId}`),
  createContactAddress: (contactId: string | number | undefined, data: any) =>
    request.post<Contact | ContactAddress>(`/contacts/${contactId}/create-contact-address`, data),
  /* eslint-disable-next-line */
  updateContactAddressLastUsed: (contactAddressesId: number, data: any) =>
    request.put<ContactAddress>(`/update-contact-addresses-last-used/${contactAddressesId}`, data),
};

export default clientContactService;
